type ImageAltType = {
  src?: {
    alt?: string;
  };
  srcAltText?: string;
};

export function getAltText(image?: ImageAltType): string | undefined {
  return image?.src?.alt !== undefined && image.src.alt !== '' ? image.src.alt : image?.srcAltText;
}
